var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("系统管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: {
                        content: _vm.editId == "" ? "新增菜单" : "编辑菜单",
                      },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "类型", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择", clearable: "" },
                            model: {
                              value: _vm.ruleForm.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "type", $$v)
                              },
                              expression: "ruleForm.type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "目录", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "菜单", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "按钮", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "按钮菜单", value: "3" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "菜单名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入菜单名称" },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上级菜单", prop: "path" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { "margin-right": "auto" },
                          attrs: {
                            props: _vm.cateProps,
                            "show-all-levels": true,
                            options: _vm.postList,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.selectData,
                            callback: function ($$v) {
                              _vm.selectData = $$v
                            },
                            expression: "selectData",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "菜单路由", prop: "url" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入菜单路由" },
                          model: {
                            value: _vm.ruleForm.url,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "url", $$v)
                            },
                            expression: "ruleForm.url",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "接口", prop: "apisAuth" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请以逗号分隔填写接口地址" },
                          model: {
                            value: _vm.ruleForm.apisAuth,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "apisAuth", $$v)
                            },
                            expression: "ruleForm.apisAuth",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "排序号", prop: "sort" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入排序号" },
                          model: {
                            value: _vm.ruleForm.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "sort", $$v)
                            },
                            expression: "ruleForm.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "菜单图标" } },
                      [
                        _c(
                          "el-popover",
                          {
                            ref: "popover",
                            attrs: {
                              placement: "bottom",
                              width: "500",
                              trigger: "click",
                            },
                            model: {
                              value: _vm.visible,
                              callback: function ($$v) {
                                _vm.visible = $$v
                              },
                              expression: "visible",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _vm.ruleForm.icon == "" ||
                                _vm.ruleForm.icon == null
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "rgb(107, 107, 241)",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.visible == !_vm.visible
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  添加图标\n                "
                                        ),
                                      ]
                                    )
                                  : _c("i", {
                                      class: [
                                        "iconfont",
                                        "icon-" + _vm.ruleForm.icon,
                                      ],
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "iconBox" },
                              _vm._l(_vm.iconList, function (item, index) {
                                return _c("i", {
                                  key: index,
                                  class: [
                                    "iconfont",
                                    "icon-" + item.font_class,
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectIcon(item.font_class)
                                    },
                                  },
                                })
                              }),
                              0
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            staticStyle: { "margin-right": "auto" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }